import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
    Grid,
    Select, 
    MenuItem 
} from '@mui/material';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';
// 🔒 부모 컴포넌트로부터 주소창 일치 여부(isLocationValid)를 정상 수신합니다.
const ActivityRegisterModal = ({ open, onClose, selectedDate, editData, onSave, onDelete, isLocationValid = false }) => {
    // 폼 상태 관리
    const [openClient, setOpenClient] = useState(false);
    const [formData, setFormData] = useState({
        activityId: null,
        usrNm: '',
        usrUuid: '',
        title: '',
        startDate: '',
        startTime: '09:00',
        endDate: '',
        endTime: '18:00',
        meetPlace: '',
        companyUuid: '',
        companyNm:'',
        content: '',
        googleEventId:''
    });

    const handleOpenClient = () => {
        setOpenClient(true);
    };
    const handleCloseClient = () => {
        setOpenClient(false);
    };

    
    // 달력에서 날짜를 선택해 모달이 열릴 때마다 날짜 및 세션 유저 초기값 직접 매핑
    useEffect(() => {
        if (open) {
            let sessionUsrNm = '담당자 정보 없음';
            let sessionUsrUuid = '';

            const localUser = localStorage.getItem('user');

            if (editData) {
                const parsedUser = JSON.parse(localUser);
                // 🔍 1. 상세 조회 및 수정 모드일 때 (넘겨받은 데이터 바인딩)
                setFormData({
                    activityId: editData.activityId || null,
                    usrNm: editData.usrNm || '',
                    usrUuid: editData.usrUuid || '',
                    title: editData.title || '',
                    startDate: editData.startDate || '',
                    startTime: editData.startTime || '09:00',
                    endDate: editData.endDate || '',
                    endTime: editData.endTime || '18:00',
                    companyUuid: editData.companyUuid || '',
                    companyNm: editData.companyNm || '',
                    meetPlace: editData.meetPlace,
                    content: editData.content || '',
                    googleEventId: editData.googleEventId || null,
                });
            } else {
                // 🔍 2. 신규 등록 모드일 때 (로컬스토리지 직접 참조하여 즉시 주입)
                if (localUser) {
                    try {
                        const parsedUser = JSON.parse(localUser);
                        sessionUsrNm = parsedUser.usrNm || '담당자 정보 없음';
                        sessionUsrUuid = parsedUser.userUuid || parsedUser.usrUuid || '';
                    } catch (e) {
                        console.error('모달 내부 로컬스토리지 user 파싱 에러:', e);
                    }
                }

                setFormData({
                    activityId: null,
                    usrNm: sessionUsrNm,
                    usrUuid: sessionUsrUuid,
                    title: '',
                    startDate: selectedDate || '',
                    startTime: '09:00',
                    endDate: selectedDate || '',
                    endTime: '18:00',
                    companyUuid: '',
                    companyNm: '',
                    meetPlace: '',
                    content: '',
                    googleEventId:'',
                });
            }
        }
    }, [selectedDate, editData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        // 1. 필수 기본 입력값 검증
        if (!formData.title || !formData.companyUuid || !formData.content) {
            alert('제목, 업체명, 내역을 모두 입력해주세요.');
            return;
        }

        // ⏱️ 2. 시간 범위 유효성 검사 (06:00 ~ 23:00)
        const startTime = formData.startTime;
        const endTime = formData.endTime;

        if (!formData.startDate || !startTime || !formData.endDate || !endTime) {
            alert('시작 및 종료 일시를 모두 입력해주세요.');
            return;
        }

        // 📅 3. 날짜+시간 전체를 기준으로 선후 관계 검사
        const startDatetime = `${formData.startDate} ${startTime}:00`;
        const endDatetime = `${formData.endDate} ${endTime}:00`;

        if (startDatetime >= endDatetime) {
            alert('시작 일시는 종료 일시보다 빨라야 합니다.');
            return;
        }

        // ✨ 모든 유효성 검사를 통과했을 때만 저장하고 모달을 닫음
        onSave(formData);
        handleClose();
    };

    const handleDeleteClick = () => {
        if (formData.activityId && typeof onDelete === 'function') {
            onDelete(formData.activityId, formData.googleEventId);

            handleClose();
        }
    };

    const handleClose = () => {
        setFormData({
            activityId: null,
            usrNm: '',
            usrUuid: '',
            title: '',
            startDate: '',
            startTime: '09:00',
            endDate: '',
            endTime: '18:00',
            companyUuid: '',
            companyNm: '',
            meetPlace: '',
            content: '',
            googleEventId:'',
        });
        onClose();
    };

    const selectedClient = (partner) => {
        // 🚀 [에러 해결 핵심]: formData가 일반 State일 때는 아래처럼 직접 객체를 복사해서 값을 변경해야 합니다.
        if (typeof formData.setFieldValue === 'function') {
            // 만약 Formik 구조가 맞다면 기존 방식 유지 (방어 코드)
            formData.setFieldValue('companyUuid', partner.partnerUuid);
            formData.setFieldValue('companyNm', partner.partnerNm);
        } else {
            // 🔥 일반 State 구조일 때: setFormData(또는 명시된 상태 변경 함수)를 호출하여 업데이트합니다.
            // 만약 상단에 상태 변경 함수명이 setFormData 라면 아래 주석을 풀고 맞춰주세요.
            if (typeof setFormData === 'function') {
                setFormData(prev => ({
                    ...prev,
                    companyUuid: partner.partnerUuid,
                    companyNm: partner.partnerNm,
                }));
            } else {
                // setFormData가 없을 경우 직접 객체 속성에 주입하는 전통적 방식 (컴포넌트 구조에 맞춰 작동)
                formData.companyUuid = partner.partnerUuid;
                formData.companyNm = partner.partnerNm;
                
                // 💡 만약 부모나 상단에서 강제 리렌더링을 일으켜야 한다면 변수 조율이 필요합니다.
                // 현재 코드 기준 강제 대입 처리로 1차 조치 완료
            }
        }
    };
    
    const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')); // ["06", "07", ..., "23"]
    const minutes = ['00', '30'];

    // 🎯 한 번에 6개만 노출하고 스크롤바를 생기게 하는 MUI MenuProps 설정
    const ITEM_HEIGHT = 36; // 메뉴 아이템 하나의 높이 (px)
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 6.5, // 6개 반 정도 노출되게 하여 스크롤 존재를 인지시킴
                width: 80,
            },
        },
    };

    const selectSx = {
        fontSize: '0.95rem',
        color: 'inherit',
        '& .MuiSelect-select': {
            padding: '0px 20px 0px 4px', // 기본 패딩 최소화
            backgroundColor: 'transparent',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none', // MUI 기본 테두리 제거 (부모 Box 테두리 활용)
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    };

    const handleTimeChange = (type, field, value) => {
        const timeField = type === 'start' ? 'startTime' : 'endTime';
        const currentTmp = formData[timeField] || '06:00';
        let [h, m] = currentTmp.split(':');

        if (field === 'hour') {
            h = value;
            if (value === '23') m = '00'; // 23시 선택 시 분은 00분 고정
        } else if (field === 'minute') {
            m = value;
        }

        setFormData(prev => ({
            ...prev,
            [timeField]: `${h}:${m}`
        }));
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const [startH, startM] = (formData.startTime || '06:00').split(':');
    const [endH, endM] = (formData.endTime || '06:00').split(':');

    // 네이티브 인풋 창 기본 스타일
    const inputStyle = {
        border: 'none',
        background: 'transparent',
        outline: 'none',
        fontFamily: 'inherit',
        fontSize: '0.95rem',
        color: '#3c4043',
        padding: '4px 0',
        width: '100%',
        cursor: 'pointer'
    };
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            {/* MUI v5 중첩 마크업 오류(validateDOMNesting) 해결: component="span" 도입 */}
            <DialogTitle sx={{ fontWeight: 'bold', pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="span" sx={{ fontWeight: 'bold' }}>
                    {formData.activityId ? '기술활동기록 상세' : '기술활동기록 등록'}
                </Typography>
            </DialogTitle>
            
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1.5 }}>
                    
                    {/* 활동 제목 */}
                    <TextField
                        label="제목"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder="예: 프로젝트 킥오프 미팅"
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />

                    {/* 담당자 (ReadOnly) */}
                    <TextField
                        label="담당자"
                        name="usrNm"
                        value={formData.usrNm}
                        disabled
                        fullWidth
                        variant="outlined"
                        size="small"
                    />

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* 📅 시작 일시 */}
                    <Box sx={{ position: 'relative', mt: 0.5 }}>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                position: 'absolute', left: '12px', top: '-8px', backgroundColor: '#fff', px: '5px',
                                color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', fontWeight: 400, zIndex: 1, pointerEvents: 'none'
                            }}
                        >
                            시작일시
                        </Typography>
                        <Box sx={{ 
                            display: 'flex', alignItems: 'center', gap: 0.5,
                            border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '8.5px 14px',
                            backgroundColor: !isLocationValid ? '#f5f5f5' : '#fff', 
                            '&:hover': { borderColor: !isLocationValid ? 'rgba(0, 0, 0, 0.23)' : 'rgba(0, 0, 0, 0.87)' },
                            '&:focus-within': isLocationValid ? { borderColor: '#1976d2', borderWidth: '2px', padding: '7.5px 13px' } : {}
                        }}>
                            <input
                                type="date"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleDateChange}
                                style={inputStyle}
                                disabled={!isLocationValid}
                            />
                            <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontSize: '0.9rem', userSelect: 'none', mx: 0.5 }}>|</Typography>
                            
                            {/* 🕒 시 선택 (MUI) */}
                            <Select
                                value={startH}
                                onChange={(e) => handleTimeChange('start', 'hour', e.target.value)}
                                disabled={!isLocationValid}
                                MenuProps={MenuProps}
                                sx={selectSx}
                            >
                                {hours.map(h => (
                                    <MenuItem key={`sh-${h}`} value={h} sx={{ fontSize: '0.9rem', py: 0.5 }}>{h}시</MenuItem>
                                ))}
                            </Select>

                            {/* 🕒 분 선택 (MUI) */}
                            <Select
                                value={startM}
                                onChange={(e) => handleTimeChange('start', 'minute', e.target.value)}
                                disabled={!isLocationValid}
                                MenuProps={MenuProps}
                                sx={selectSx}
                            >
                                {startH === '23' ? (
                                    <MenuItem value="00" sx={{ fontSize: '0.9rem', py: 0.5 }}>00분</MenuItem>
                                ) : (
                                    minutes.map(m => (
                                        <MenuItem key={`sm-${m}`} value={m} sx={{ fontSize: '0.9rem', py: 0.5 }}>{m}분</MenuItem>
                                    ))
                                )}
                            </Select>
                        </Box>
                    </Box>

                    {/* 📅 종료 일시 */}
                    <Box sx={{ position: 'relative', mt: 0.5 }}>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                position: 'absolute', left: '12px', top: '-8px', backgroundColor: '#fff', px: '5px',
                                color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', fontWeight: 400, zIndex: 1, pointerEvents: 'none'
                            }}
                        >
                            종료일시
                        </Typography>
                        <Box sx={{ 
                            display: 'flex', alignItems: 'center', gap: 0.5,
                            border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '8.5px 14px',
                            backgroundColor: !isLocationValid ? '#f5f5f5' : '#fff',
                            '&:hover': { borderColor: !isLocationValid ? 'rgba(0, 0, 0, 0.23)' : 'rgba(0, 0, 0, 0.87)' },
                            '&:focus-within': isLocationValid ? { borderColor: '#1976d2', borderWidth: '2px', padding: '7.5px 13px' } : {}
                        }}>
                            <input
                                type="date"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleDateChange}
                                style={inputStyle}
                                disabled={!isLocationValid}
                            />
                            <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontSize: '0.9rem', userSelect: 'none', mx: 0.5 }}>|</Typography>
                            
                            {/* 🕒 시 선택 (MUI) */}
                            <Select
                                value={endH}
                                onChange={(e) => handleTimeChange('end', 'hour', e.target.value)}
                                disabled={!isLocationValid}
                                MenuProps={MenuProps}
                                sx={selectSx}
                            >
                                {hours.map(h => (
                                    <MenuItem key={`eh-${h}`} value={h} sx={{ fontSize: '0.9rem', py: 0.5 }}>{h}시</MenuItem>
                                ))}
                            </Select>

                            {/* 🕒 분 선택 (MUI) */}
                            <Select
                                value={endM}
                                onChange={(e) => handleTimeChange('end', 'minute', e.target.value)}
                                disabled={!isLocationValid}
                                MenuProps={MenuProps}
                                sx={selectSx}
                            >
                                {endH === '23' ? (
                                    <MenuItem value="00" sx={{ fontSize: '0.9rem', py: 0.5 }}>00분</MenuItem>
                                ) : (
                                    minutes.map(m => (
                                        <MenuItem key={`em-${m}`} value={m} sx={{ fontSize: '0.9rem', py: 0.5 }}>{m}분</MenuItem>
                                    ))
                                )}
                            </Select>
                        </Box>
                    </Box>
                </Box>

                    {/* 업체명 */}
                    {/* 🚀 [정렬 보정]: 업체 입력창과 버튼이 세로로 꺾이지 않고 가로 일직선으로 예쁘게 배치되도록 컨테이너 그리드를 생성합니다. */}
                    {/* 🚀 [한 줄 고정 핵심 1]: 줄바꿈을 원천 차단(nowrap)하고 가로 플렉스로 부드럽게 정렬합니다. */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            flexDirection: 'row', 
                            flexWrap: 'nowrap', 
                            alignItems: 'center', 
                            gap: '8px', // 인풋창과 버튼 사이의 정갈한 간격
                            width: '100%',
                            boxSizing: 'border-box'
                        }}
                    >
                        {/* 🚀 [한 줄 고정 핵심 2]: 인풋창이 우측 버튼 공간을 제외한 남은 공간을 알아서 100% 꽉 채웁니다. */}
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                            <TextField
                                label="업체"
                                name="companyNm" 
                                value={formData.companyNm || ''} 
                                placeholder="고객사를 선택하세요."
                                fullWidth
                                size="small"
                                required
                                InputProps={{ 
                                    readOnly: !isLocationValid || true 
                                }} 
                            />
                            
                            {/* 백엔드 전송용 히든 필드 */}
                            <input 
                                type="hidden" 
                                name="companyUuid" 
                                value={formData.companyUuid || ''} 
                            />
                        </Box>

                        {/* 🚀 [한 줄 고정 핵심 3]: 버튼은 모바일에서도 절대 크기가 줄어들거나 찌그러지지 않고 고유 형태를 보존합니다. */}
                        <Box sx={{ flexShrink: 0 }}>
                            <Button
                                color="secondary"
                                variant="outlined"
                                size="small"
                                onClick={handleOpenClient}
                                disabled={!isLocationValid} 
                                sx={{ 
                                    height: '40px', 
                                    whiteSpace: 'nowrap', // 글자가 아래로 꺾이는 현상 방지
                                    px: '12px', // 모바일 폭에 맞춘 최적화 여백
                                    fontSize: '0.8rem' // 모바일 가독성 맞춤 폰트 스케일
                                }} 
                            >
                                고객사 선택
                            </Button>
                        </Box>
                    </Box>


                    {/* 업체명 */}
                    
                    <TextField
                        label="장소"
                        name="meetPlace"
                        value={formData.meetPlace}
                        onChange={handleChange}
                        placeholder="예: 에이치씨인포"
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />
                    {/* 활동 내역 */}
                    <TextField
                        label="내용"
                        name="content"
                        value={formData.content}
                        onChange={handleChange}
                        placeholder="내용을 상세히 입력하세요."
                        multiline
                        rows={4}
                        fullWidth
                        size="small"
                        required
                        InputProps={{ readOnly: !isLocationValid }} // 🔒 지정 경로 아닐 때 수정 차단
                    />
                </Box>
            </DialogContent>
            
            {/* 하단 액션 버튼 바 */}
            <DialogActions sx={{ px: 3, py: 2, justifyContent: (formData.activityId && isLocationValid) ? 'space-between' : 'flex-end' }}>
                {/* 🔒 올바른 주소이고, 수정 모드일 때만 하단 왼쪽에 [삭제] 버튼 노출 */}
                {formData.activityId && isLocationValid && (
                    <Button onClick={handleDeleteClick} color="error" variant="outlined">
                        삭제
                    </Button>
                )}
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={handleClose} color="inherit" variant="outlined">
                        {isLocationValid ? '취소' : '닫기'}
                    </Button>
                    
                    {/* 🔒 올바른 주소일 때만 [저장] 버튼 활성화 노출 */}
                    {isLocationValid && (
                        <Button onClick={handleSubmit} color="primary" variant="contained">
                            저장
                        </Button>
                    )}
                </Box>
            </DialogActions>
            {openClient && (
                <PartnerModalConatiner
                    link
                    title="고객사 선택"
                    open={openClient}
                    handleClose={handleCloseClient}
                    selectedPartner={selectedClient}
                    selectedPartnerTyp={'고객사'}
                    isModal={true}
                />
            )}
        </Dialog>
    );
};

export default ActivityRegisterModal;
